export default __webpack_public_path__ + "static/media/hero-bot-right.5ae5a984.svg";